import { render, staticRenderFns } from "./ManufacturerList.vue?vue&type=template&id=2e17644c&"
import script from "./ManufacturerList.vue?vue&type=script&lang=js&"
export * from "./ManufacturerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports